import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseAuth } from 'src/shared/models';

@Injectable({providedIn: 'root'})

export class AuthService {
  private url = '';

  constructor(private http: HttpClient) {
    const isLocal = window.location.hostname === 'localhost';
    this.url = isLocal
    ? '/login'                                // Usar proxy local
    : `${environment.baseURL}/login`;         // Usar URL con los environments
  }

  Post(username:string, password:string):Observable<ResponseAuth>{
    const body = {
      username,
      password
    }

    return this.http.post<ResponseAuth>(`${this.url}`, body);
  }
}
